import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Block } from '@mui/icons-material';
import { useIsMobile } from '@uplift/hooks';
import { useMemo } from 'react';

export const OnboardingError: React.VFC = () => {
  const { classes } = useStyles();
  const isMobile = useIsMobile('sm');

  const content = useMemo(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('error') === 'invalid_invite') {
      return (
        <>
          <Typography variant="h6">
            This invite has expired
          </Typography>
          <Typography>
            Check your email for the most recent invite with a new link to set up your account.
          </Typography>
          <Typography>
            Didn&apos;t get one? Contact <a href="mailto:help@joinuplift.co" className={classes.link}>help@joinuplift.co</a>
          </Typography>
        </>
      );
    }

    return (
      <Box>
        An unknown error has happened
      </Box>
    );
  }, [ classes.link ]);

  return (
    <Box className={isMobile ? classes.mobile : classes.desktop}>
      <Box className={classes.content}>
        <Block className={classes.icon} />
        {content}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()(theme => ({
  content: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    maxWidth: '362px',
    textAlign: 'center',
    paddingTop: theme.spacing(13),
    width: '100%'
  },
  desktop: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  icon: {
    color: theme.palette.text.secondary,
    height: '60px',
    width: '60px',
  },
  link: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    textDecoration: 'none'
  },
  mobile: {
    display: 'grid',
    placeItems: 'center',
    width: '100%',
  }
}));
